import { AgentsAudienceReactionsIcon, Icon, type IconProps } from '@grammarly/design-system'

type ReaderReactionAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const ReaderReactionAgentIcon = ({
  size,
  accessibilityLabel,
}: ReaderReactionAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsAudienceReactionsIcon}
      accessibilityLabel={accessibilityLabel ?? 'Reader Reaction Agent'}
    />
  )
}
